"use client";

import { Play } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="7582" id="hero" className="relative overflow-hidden bg-background text-foreground py-28 md:py-40">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute left-[8%] top-[18%] h-[280px] w-[360px] md:h-[420px] md:w-[520px] bg-secondary opacity-[0.15] blur-[2px]" style={{
        animation: "pebbleDriftA 14s ease-in-out infinite alternate"
      }} />
        <div className="absolute bottom-[12%] right-[6%] h-[260px] w-[340px] md:h-[400px] md:w-[500px] bg-primary opacity-[0.1] blur-[2px]" style={{
        animation: "pebbleDriftB 14s ease-in-out infinite alternate"
      }} />
      </div>

      <style>{`
        @keyframes pebbleDriftA {
          0% { transform: translate(0px, 0px); }
          100% { transform: translate(12px, -10px); }
        }
        @keyframes pebbleDriftB {
          0% { transform: translate(0px, 0px); }
          100% { transform: translate(-12px, 10px); }
        }
        @keyframes wordRise {
          0% { opacity: 0; transform: translateY(16px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        .word-rise > span {
          display: inline-block;
          opacity: 0;
          animation: wordRise 0.62s cubic-bezier(0.22, 1, 0.36, 1) forwards;
        }
        .underline-swash {
          background-image: linear-gradient(to right, var(--secondary), var(--secondary));
          background-repeat: no-repeat;
          background-position: 0 88%;
          background-size: 100% 8px;
          padding-bottom: 2px;
        }
      `}</style>

      <div ref={ref} className="relative z-10 mx-auto max-w-[880px] px-6 md:px-8">
        {}
        <div className={`flex justify-center transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="inline-flex items-center rounded-lg bg-secondary/20 px-3 py-1.5 text-xs font-semibold uppercase tracking-[0.08em] text-secondary-foreground">
            Professional Excellence
          </span>
        </div>

        {}
        <h1 className="font-default mt-8 text-center text-foreground word-rise" style={{
        fontSize: "clamp(2.75rem, 6vw, 5.25rem)",
        fontWeight: 700,
        letterSpacing: "-0.02em",
        lineHeight: 1.02
      }}>
          <span style={{
          animationDelay: "0ms"
        }}>Solutions&nbsp;</span>
          <span style={{
          animationDelay: "90ms"
        }}>that&nbsp;</span>
          <span style={{
          animationDelay: "180ms"
        }}>drive&nbsp;</span>
          <span style={{
          animationDelay: "270ms"
        }}>your&nbsp;</span>
          <span style={{
          animationDelay: "360ms"
        }}>
            <em className="italic font-default underline-swash">growth</em>.
          </span>
        </h1>

        {}
        <p className={`mx-auto mt-8 max-w-[600px] text-center text-muted-foreground transition-all duration-700 delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        fontSize: "clamp(1.0625rem, 1.15vw, 1.1875rem)",
        lineHeight: 1.6
      }}>
          Strategic, results-driven consulting services designed to optimize your operations, scale your impact, and secure your competitive advantage.
        </p>

        {}
        <div className={`mt-10 flex flex-col items-center justify-center gap-5 sm:flex-row sm:gap-4 transition-all duration-700 delay-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Button asChild size="lg" className="rounded-lg bg-primary px-7 py-6 text-[0.9375rem] font-semibold text-primary-foreground shadow-md hover:bg-primary/90 hover:scale-[1.04] transition-transform duration-200" style={{
          transitionTimingFunction: "cubic-bezier(0.34, 1.4, 0.64, 1)"
        }}>
            <Link to="#">Explore Services</Link>
          </Button>

          <Link to="/ContactPage" className="group inline-flex items-center gap-2 text-foreground">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-card text-foreground shadow-sm transition-transform duration-200 group-hover:scale-110">
              <Play className="h-4 w-4" fill="currentColor" />
            </span>
            <span className="text-[0.9375rem] font-medium" style={{
            textDecoration: "underline",
            textDecorationColor: "var(--secondary)",
            textDecorationThickness: "1.5px",
            textUnderlineOffset: "6px"
          }}>
              Book a consultation
            </span>
          </Link>
        </div>
      </div>
    </section>;
}